<template>
  <div class="footer">
    <footer>
      <div class="row">
        <div class="col disclaimer-link">
          <router-link class="assumption-button col d-print-none" :to="{ name: 'Assumptions', params: {activeTab: 'disclaimer' } }" tabindex="0">Assumptions &amp; disclaimer</router-link>
        </div>
        <div class="col build-by-link">
          <a class="g-logo" href="//www.gallagherdigital.com.au" target="_blank" :aria-label="'Gallagher '+new Date().getFullYear()"></a>
          <a href="//www.gallagherdigital.com.au" target="_blank" :aria-label="'Gallagher '+new Date().getFullYear()">
            © <span>Gallagher</span> {{new Date().getFullYear()}}
          </a>
          
        </div>
      </div>
      
      
      {{ msg }}
    </footer>
  </div>
</template>

<script>
export default {
  name: 'CustomFooter',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
